import $ from 'jquery';

export default class TemplateGiftCard {
  constructor(template) {
    this.el = template.el;
    this.$el = $(this.el);
    return this.addQrCode();
  }

  addQrCode() {
    const qrWrapper = $('[data-qr-code]', this.el);

    return new QRCode(qrWrapper[0], {
      text: qrWrapper.data('qr-code'),
      width: 120,
      height: 120,
    });
  }
}
